
<template>
  <div class="mine">
    <div class="top">
      <img v-if="data.infos && data.infos.head_pic" :src="data.infos.head_pic" />
      <img v-else src="./../../assets/school/user.png" />
      <p>{{ data.nickname }}</p>
      <!-- <div>
        <div class="item">
          <div>
            <img src="./../../assets/school/allOrder.png" alt="" />
          </div>
          <span>全部订单</span>
        </div>
        <div class="item">
          <div>
            <img src="./../../assets/school/unpaid.png" alt="" />
            <span class="dot">20</span>
          </div>
          <span>待支付</span>
        </div>
        <div class="item">
          <div>
            <img src="./../../assets/school/accomplish.png" alt="" />
          </div>
          <span>已完成</span>
        </div>
      </div> -->
    </div>
    <div class="mineContent">
      <div class="item" @click="toCollect()">
        <div>
          <img src="./../../assets/school/collect1.png" />
          <span>收藏</span>
        </div>
        <img src="./../../assets/school/right.png" />
      </div>
      <div class="item" @click="toAttention()">
        <div>
          <img src="./../../assets/school/collect3.png" />
          <span>关注</span>
        </div>
        <img src="./../../assets/school/right.png" />
      </div>
      <!-- <van-divider /> -->
      <div class="item" @click="Notescontact()">
        <div>
          <img src="./../../assets/school/help.png" />
          <span>客服与帮助</span>
        </div>
        <img src="./../../assets/school/right.png" />
      </div>
      <!-- <div class="item">
        <div>
          <img
            src="./../../assets/school/feedback.png"
            alt=""
          />
          <span>意见反馈</span>
        </div>
        <img
          src="./../../assets/school/right.png"
          alt=""
        />
      </div> -->
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      data: {},
    };
  },
  mounted() {
    this.$api.setToken(JSON.parse(sessionStorage.getItem("token")));
    this.getUserDetail();
  },
  methods: {
    // 收藏
    toCollect() {
      this.$router.push({
        path: "/school/collect",
      });
    },
    // 关注
    toAttention() {
      this.$router.push({
        path: "/school/attention",
      });
    },
    // 联系客服
    Notescontact() {
      this.params("58", "58", "customerService");
    },
    // 获取会员信息
    getUserDetail() {
      this.$api.get("member/member/user/detail").then((res) => {
        // console.log(res)
        this.data = res;
      });
    },
  },
};
</script>

<style scoped>
.mine {
  height: 100%;
  background-color: #ffffff;
}
.top {
  width: 100%;
  height: 322px;
  background: url("./../../assets/school/userCenter.png") no-repeat;
  background-size: cover;
  position: relative;
}
.top > img {
  width: 72px;
  height: 72px;
  border: 4px solid #ffffff;
  border-radius: 50%;
  position: absolute;
  left: 50%;
  bottom: 158px;
  transform: translateX(-50%);
}
.top > p {
  position: absolute;
  left: 50%;
  bottom: 124px;
  transform: translateX(-50%);
  color: #404247;
  font-size: 16px;
  font-weight: bold;
}
.top > div {
  width: 343px;
  height: 84px;
  position: absolute;
  left: 50%;
  bottom: 0px;
  transform: translateX(-50%);
  background: #ffffff;
  box-shadow: 0px 4px 10px 0px #f2f6ff;
  border-radius: 8px;
  display: flex;
  justify-content: space-around;
}
.top > div .item {
  display: flex;
  flex-direction: column;
  align-items: center;
}
.top > div .item > div {
  width: 40px;
  height: 40px;
  margin-bottom: 4px;
  margin-top: 11px;
  position: relative;
}
.top > div .item .dot {
  display: inline-block;
  padding: 2px 5px;
  border-radius: 12px;
  position: absolute;
  top: -2px;
  left: 23px;
  background: linear-gradient(180deg, #f77eab 0%, #eb4872 100%);
  font-size: 12px;
  color: #ffffff;
  border: 2px solid #ffffff;
  transform: scale(0.8);
  font-weight: bold;
}
.top > div .item img {
  width: 40px;
  height: 40px;
}
.top > div .item span {
  color: #9ca1ad;
  font-size: 13px;
}
/* content */
.mineContent {
  margin: 7px 19px 0;
  /* 二期删掉 */
  position: relative;
  top: -94px;
}
.mine .mineContent .item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 35px;
  padding: 6px 0;
  color: #404247;
  font-size: 16px;
}
.mine .mineContent .item > div {
  display: flex;
  align-items: center;
}
.mine .mineContent .item > img {
  width: 12px;
  height: 12px;
}
.mine .mineContent .item > div img {
  width: 24px;
  height: 24px;
  margin-right: 10px;
}

.van-divider {
  margin: 34px 0 -9px;
}
</style>